import React from 'react';

import {
    Chip
} from '@mui/material';

import { getEnvConfigs } from '../../configs/envConfigs';
import { routeTypes } from '../../hooks/useSystemRoutes'
import { CommonIcons, icons } from '../common/CommonIcons';

export function RouteTypeChip(props) {

    const {
        routeType
    } = props

    // const getIcon = ({ routeType }) => {
    //     if(routeType === routeTypes.admin){
    //         return (
    //             <CommonIcons name={icons.warehouse} />
    //         )
    //     }

    //     if(routeType === routeTypes.retail){
    //         return (
    //             <CommonIcons name={icons.minus} />
    //         )
    //     }

    //     if(routeType === routeTypes.retail){
    //         return (
    //             <CommonIcons name={icons.warehouse} />
    //         )
    //     }

    //     return <></>
    // }

    const getLabel = ({ routeType }) => {
        return `${routeType} v${getEnvConfigs().appVersion}`
    }

    return (
        <Chip
            // icon={getIcon({ routeType })}
            label={getLabel({ routeType })}
            color="primary"
            sx={{
                ml: 1,
                px: 1,
                textTransform: 'capitalize',
            }}
            variant='outlined'
        // size='small'
        // {...props}
        />
    )
}

